module.exports = __webpack_public_path__ + "public/img/07.16a32b88.jpg";